var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcPerson(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.333 3C23.3579 3 24.9998 4.64115 25 6.66602V21.333C25 23.3581 23.3581 25 21.333 25H6.66699C4.64195 25 3 23.3581 3 21.333V6.66602C3.00021 4.64115 4.64208 3 6.66699 3H21.333ZM11 16.167C8.79099 16.167 7.0002 17.958 7 20.167V21.001C7.00015 21.5463 7.43677 21.9891 7.97949 22H20.0205C20.5632 21.9891 20.9999 21.5463 21 21.001V20.167C20.9998 17.958 19.209 16.167 17 16.167H11ZM14 8C12.067 8 10.5 9.567 10.5 11.5C10.5 13.433 12.067 15 14 15C15.933 15 17.5 13.433 17.5 11.5C17.5 9.567 15.933 8 14 8Z",
    fill: "url(#paint0_linear_9532_371259)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9532_371259",
    x1: 14,
    y1: 6,
    x2: 14,
    y2: 24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D0D0D0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPerson);
export default __webpack_public_path__ + "static/media/ic-person.e95b597ef2ae266b4371a18c5c63bcd4.svg";
export { ForwardRef as ReactComponent };